import { render, staticRenderFns } from "./ShortHaul.vue?vue&type=template&id=12b3f48f&scoped=true&"
import script from "./ShortHaul.vue?vue&type=script&lang=js&"
export * from "./ShortHaul.vue?vue&type=script&lang=js&"
import style0 from "./ShortHaul.vue?vue&type=style&index=0&id=12b3f48f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3f48f",
  null
  
)

export default component.exports